import { render, staticRenderFns } from "./FinancesExpensesForm.vue?vue&type=template&id=1afbb506"
import script from "./FinancesExpensesForm.vue?vue&type=script&lang=js"
export * from "./FinancesExpensesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports